export type StoredSession = {
  sessionId?: string;
  visitorId?: string;
  projectId?: string;
  conversationId?: string;
  conversationToken?: string;
  lastMessageAt?: string;
};

function key(widgetKey: string) {
  return `cbm-widget:${widgetKey}`;
}

export function loadStoredSession(widgetKey: string): StoredSession {
  try {
    const raw = window.localStorage.getItem(key(widgetKey));
    return raw ? (JSON.parse(raw) as StoredSession) : {};
  } catch {
    return {};
  }
}

export function persistStoredSession(widgetKey: string, value: StoredSession): void {
  window.localStorage.setItem(key(widgetKey), JSON.stringify(value));
}
